module.exports = __webpack_public_path__ + "assets/add-icon.a2f73e90.svg";